import { useEffect, useState } from "react";
import './NavigationBar.css';
import Cookies from "js-cookie";
import { Switch, Select } from "antd";
import { SearchOutlined } from '@ant-design/icons';


function NavigationBar({ allTags, selectedTags, setSelectedTags, showSideMenu, setShowSideMenu, windowWidth }) {
  const handleLanguageChange = (checked) => {
    const language = checked ? "en" : "de";
    Cookies.set("language", language);
    window.location.reload();
  };
  const [options, setOptions] = useState([{ value: "Acorn", label: "Acorn" }]);

  useEffect(() => {
    if (Array.isArray(allTags)) {
      setOptions(allTags.map(tag => ({ value: tag, label: tag })));
      console.log("check");
    }
  }, [allTags]);
  console.log(options);
  return (
    <>
      <div
        id="navbar"
        style={{
          width: '100%',
          minHeight: '50px',
          backgroundColor: '#0B0E13',
          position: 'fixed',
          top: 0,
          left: 0,
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: windowWidth < 600 ? 'flex-start' : 'space-between',
          paddingLeft: 24,
          paddingRight: 24,
        }}
      >
        {windowWidth < 600 ? (
          // MOBILE: Select and Switch side by side, left-aligned
          <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            <Select
              styles={{
                popup: {
                  root: {
                    zIndex: 9999,
                    backgroundColor: "#222244",
                  }
                }
              }}
              mode="multiple"
              showSearch
              style={{
                width: "70vw",
                maxWidth: "300px",
                marginRight: 12,
              }}
              placeholder=""
              optionFilterProp="label"
              options={options}
              value={selectedTags}
              onChange={setSelectedTags}
              suffixIcon={<SearchOutlined style={{ color: "#444488" }} />}
              filterOption={(input, option) =>
                option.label
                  .toLowerCase()
                  .split(' ')
                  .some(word => word.startsWith(input.toLowerCase()))
              }
              getPopupContainer={() => document.getElementById('navbar')}
            />
            <Switch
              style={{ marginLeft: 30 }}
              checkedChildren="EN"
              unCheckedChildren="DE"
              onChange={handleLanguageChange}
              defaultChecked={Cookies.get("language") === "en"}

            />
          </div>
        ) : (
          // DESKTOP: Select centered, Switch right
          <>
            <div style={{ flex: 1 }} />
            <div style={{
              flex: 1,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
              <Select
                styles={{
                  popup: {
                    root: {
                      zIndex: 9999,
                      backgroundColor: "#222244",
                    }
                  }
                }}
                mode="multiple"
                showSearch
                style={{
                  width: "350px",
                  maxWidth: "450px"
                }}
                placeholder=""
                optionFilterProp="label"
                options={options}
                value={selectedTags}
                onChange={setSelectedTags}
                suffixIcon={<SearchOutlined style={{ color: "#444488" }} />}
                filterOption={(input, option) =>
                  option.label
                    .toLowerCase()
                    .split(' ')
                    .some(word => word.startsWith(input.toLowerCase()))
                }
                getPopupContainer={() => document.getElementById('navbar')}
              />
            </div>
            <div style={{
              flex: 1,
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center'
            }}>
              <Switch
                style={{ right: 40 }}
                checkedChildren="EN"
                unCheckedChildren="DE"
                onChange={handleLanguageChange}
                defaultChecked={Cookies.get("language") === "en"}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default NavigationBar;
